/**
 * ContextMenu — portal-rendered rename/delete menu triggered from
 * the sidebar's "•••" buttons on projects and chats.
 *
 * Phase E1: extracted from Sidebar.tsx.
 */

import { createPortal } from 'react-dom';
import { FileEdit, Pencil, Trash2 } from 'lucide-react';
import type { ContextMenuTarget } from './types';

type Props = {
    target: ContextMenuTarget;
    onEditProject: () => void;
    onRename: () => void;
    onDelete: () => void;
};

export default function ContextMenu({ target, onEditProject, onRename, onDelete }: Props) {
    return createPortal(
        <div
            className="context-menu"
            style={{ top: target.y, left: target.x }}
            onMouseDown={(e) => e.stopPropagation()}
        >
            {target.type === 'project' && (
                <button
                    type="button"
                    className="context-menu-item"
                    onClick={onEditProject}
                >
                    <FileEdit size={14} />
                    Edit Project
                </button>
            )}
            <button type="button" className="context-menu-item" onClick={onRename}>
                <Pencil size={14} />
                Rename
            </button>
            <button type="button" className="context-menu-item danger" onClick={onDelete}>
                <Trash2 size={14} />
                Delete
            </button>
        </div>,
        document.body,
    );
}
